import React, { useEffect } from "react"
import { usePathname } from "next/navigation"
import Script from "next/script"
import Session from "supertokens-auth-react/recipe/session"
import { keys, store } from "@utils/store"
import { appInfo } from "config/appInfo"

import ThirdParty from "supertokens-auth-react/recipe/thirdparty"
import { message } from "@components/Message/message"

const closeModal = () => store.set(keys.loginModalVisible, { isVisible: false })

export function SignInWithGoogle() {
    const pathname = usePathname()
    let clientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
    let sessionContext = Session.useSessionContext()

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.onSignIn = onSignIn
        }
    }, [])

    let onSignIn = async function (data) {
        try {
            // let frontendRedirectURI = `${appInfo.websiteDomain}${appInfo.websiteBasePath}/callback/${provider}`
            // let params = {
            //     thirdPartyId: provider,

            //     // This is where Google should redirect the user back after login or error.
            //     // This URL goes on the Google's dashboard as well.
            //     frontendRedirectURI: frontendRedirectURI
            // }
            // // Apple is handled specially on the server
            // if (provider === "apple") {
            //     // This URL goes on the Apple's dashboard
            //     params.redirectURIOnProviderDashboard = `${appInfo.apiDomain}${appInfo.apiBasePath}/callback/${provider}`
            // }
            // let authUrl = await getAuthorisationURLWithQueryParamsAndSetState(params)

            // const result = await fetch(`${appInfo.apiDomain}${appInfo.apiBasePath}/signinup`, {
            //     method: "POST",
            //     body: JSON.stringify({
            //         thirdPartyId: "google",
            //         frontendRedirectURI: appInfo.websiteDomain + pathname, //because this is xhr, not used. Could redirect, if needed
            //         oAuthTokens: {
            //             id_token: response.credential
            //         }
            //     })
            // })

            let success = false
            if (data.credential) {
                // we do this call so that the state is created and saved in storage.
                await ThirdParty.getAuthorisationURLWithQueryParamsAndSetState({
                    thirdPartyId: "google",
                    frontendRedirectURI: appInfo.websiteDomain + pathname // window.location.toString(),
                })
                const stateInfo = await ThirdParty.getStateAndOtherInfoFromStorage()
                if (data.credential && stateInfo !== undefined) {
                    const result = await ThirdParty.signInAndUp({
                        userContext: {
                            id_token: data.credential,
                            state: stateInfo.stateForAuthProvider
                        }
                    })

                    // should trigger useEffect
                    if (result.status === "OK") {
                        success = true
                        closeModal()
                    }
                }
            }

            // should trigger useEffect
            if (!success) {
                message.error("Google Auth issue. Try again.") // for notifications
            }
        } catch (err) {
            message.error(err.message ? `Unknown Sign In Error: ${err.message}` : "Unknown Sign In Error") // for notificationse
        }
    }

    return (
        <>
            <Script src="https://accounts.google.com/gsi/client" strategy="lazyOnload" />
            {sessionContext.loading || sessionContext.doesSessionExist ? null : (
                <div id="g_id_onload" data-client_id={clientId} data-context="signin" data-callback="onSignIn" data-itp_support="true" data-use_fedcm_for_prompt="true"></div>
            )}
        </>
    )
}
